import z$1 from "zod";
//#region src/chain/chain.ts
let Chain = /* @__PURE__ */ function(Chain) {
	Chain["ETH"] = "eth";
	Chain["ARB"] = "arb";
	Chain["FLOW"] = "flow";
	Chain["MATIC"] = "matic";
	Chain["OPT"] = "opt";
	Chain["SOLANA"] = "solana";
	Chain["ASTAR"] = "astar";
	Chain["POLYGONZKEVM"] = "polygonzkevm";
	Chain["STARKNET"] = "starknet";
	Chain["BASE"] = "base";
	Chain["ZKSYNC"] = "zksync";
	Chain["ZORA"] = "zora";
	Chain["FRAX"] = "frax";
	Chain["BNB"] = "bnb";
	Chain["AVAX"] = "avax";
	Chain["ARBNOVA"] = "arbnova";
	Chain["ALCHEMY"] = "alchemy";
	Chain["WORLDCHAIN"] = "worldchain";
	Chain["ZETACHAIN"] = "zetachain";
	Chain["BLAST"] = "blast";
	Chain["SCROLL"] = "scroll";
	Chain["LINEA"] = "linea";
	Chain["GNOSIS"] = "gnosis";
	Chain["FANTOM"] = "fantom";
	Chain["MANTLE"] = "mantle";
	Chain["CELO"] = "celo";
	Chain["BERACHAIN"] = "berachain";
	Chain["METIS"] = "metis";
	Chain["OPBNB"] = "opbnb";
	Chain["POLYNOMIAL"] = "polynomial";
	Chain["SHAPE"] = "shape";
	Chain["BOB"] = "bob";
	Chain["CROSSFI"] = "crossfi";
	Chain["IOTA"] = "iota";
	Chain["MODE"] = "mode";
	Chain["MOONBASE"] = "moonbase";
	Chain["MOONBEAM"] = "moonbeam";
	Chain["MOONRIVER"] = "moonriver";
	Chain["PALM"] = "palm";
	Chain["SHIDEN"] = "shiden";
	Chain["SEI"] = "sei";
	Chain["KINTO"] = "kinto";
	Chain["PLUME"] = "plume";
	Chain["ANIME"] = "anime";
	Chain["RACE"] = "race";
	Chain["APECHAIN"] = "apechain";
	Chain["APEX"] = "apex";
	Chain["BOSS"] = "boss";
	Chain["LENS"] = "lens";
	Chain["SONEIUM"] = "soneium";
	Chain["GEIST"] = "geist";
	Chain["SOCIALNETWORK"] = "socialnetwork";
	Chain["ALCHEMYARB"] = "alchemyarb";
	Chain["ROOTSTOCK"] = "rootstock";
	Chain["LUMIA"] = "lumia";
	Chain["UNICHAIN"] = "unichain";
	Chain["SONIC"] = "sonic";
	Chain["SPOTLIGHT"] = "spotlight";
	Chain["XMTP"] = "xmtp";
	Chain["CHILIZ"] = "chiliz";
	Chain["ABSTRACT"] = "abstract";
	Chain["K2"] = "k2";
	Chain["METABASED"] = "metabased";
	Chain["MONAD"] = "monad";
	Chain["SUPERSEED"] = "superseed";
	Chain["DEGEN"] = "degen";
	Chain["UNITE"] = "unite";
	Chain["INK"] = "ink";
	Chain["SETTLUS"] = "settlus";
	Chain["ODYSSEY"] = "odyssey";
	Chain["RONIN"] = "ronin";
	Chain["STANDARD"] = "standard";
	Chain["SYNDICATE"] = "syndicate";
	Chain["HUMANITY"] = "hunanity";
	Chain["XPROTOCOL"] = "xprotocol";
	Chain["ALTERSCOPE"] = "alterscope";
	Chain["GENSYN"] = "gensyn";
	Chain["TEA"] = "tea";
	Chain["SPARKPOINT"] = "sparkpoint";
	Chain["OPENLOOT"] = "openloot";
	Chain["RISE"] = "rise";
	Chain["BITCOIN"] = "bitcoin";
	Chain["MARS"] = "mars";
	Chain["EARNM"] = "earnm";
	Chain["STORY"] = "story";
	Chain["WYLERCHAIN"] = "wylerchain";
	Chain["MEGAETH"] = "megaeth";
	Chain["APTOS"] = "aptos";
	Chain["SUI"] = "sui";
	Chain["WORLDMOBILE"] = "worldmobile";
	Chain["CONVERGE"] = "converge";
	Chain["HYPERLIQUID"] = "hyperliquid";
	Chain["V"] = "v";
	Chain["PLASMA"] = "plasma";
	Chain["ROBINHOOD"] = "robinhood";
	Chain["STELLAR"] = "stellar";
	return Chain;
}({});
/**
* Static set of all valid `ChainIds`. Once we're depending on the Alchemy `DynamicConfigService`,
* we won't be able to maintain a static set of `ChainIds`, so this object should be used sparingly
* in the meantime.
*
* For now, it's mostly used as a placeholder for `ChainId` validation and in tests.
*/
const CHAIN_IDS = new Set(Object.keys(Chain));
/**
* Once we're relying on a `DynamicConfigService`, we won't be able to statically validate `ChainIds`, so we'll
* have to validate incoming string values at runtime against a set of valid `ChainIds` fetched from the `DynamicConfigService`.
*
* This factory fn returns a Zod schema that validates a string as a `ChainId`, given a `validator` (most likely a method on
* a future `DynamicConfigService` that checks whether the value exists in a cache of valid `ChainIds`).
* @param validator Fn that returns `true` if the `ChainId` is a `ChainId`, `false` otherwise.
*/
function chainIdSchemaFactory(validator) {
	return z$1.string().transform(async (value, ctx) => {
		if (!await validator(value)) {
			ctx.addIssue({
				code: z$1.ZodIssueCode.custom,
				message: `${value} is not a ChainId`
			});
			return z$1.NEVER;
		}
		return value;
	});
}
//#endregion
export { CHAIN_IDS, Chain, chainIdSchemaFactory };

//# sourceMappingURL=chain.js.map